import { Box, Slider, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useFormContext } from 'react-hook-form'
import { ILot } from 'types/lots'

export const WeightSliders = ({ isDisabled }: { isDisabled: boolean }) => {
  const { t } = useTranslation()
  const { watch, setValue } = useFormContext<ILot>()
  const technicalBidWeight = watch('technicalBidWeight')
  const procurementBidWeight = watch('procurementBidWeight')

  return (
    <Box my={2} width="60%">
      <Typography gutterBottom>
        {t('price-proposal')} - {procurementBidWeight}
      </Typography>
      <Slider
        aria-label={t('price-proposal')}
        value={procurementBidWeight}
        step={5}
        marks
        min={10}
        max={100}
        onChange={(_, value) => {
          setValue('procurementBidWeight', value as number)
          setValue('technicalBidWeight', 100 - ((value as number) ?? 0))
        }}
        disabled={isDisabled}
      />

      <Typography gutterBottom>
        {t('technical-proposal')} - {technicalBidWeight}
      </Typography>
      <Slider
        aria-label={t('price-proposal')}
        value={technicalBidWeight}
        step={5}
        marks
        min={10}
        max={100}
        onChange={(_, value) => {
          setValue('technicalBidWeight', value as number)
          setValue('procurementBidWeight', 100 - ((value as number) ?? 0))
        }}
        disabled={isDisabled}
      />
    </Box>
  )
}
